import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { useScreenAndProtectContext } from '../../ScreenAndProtect';
import useViewProtectedPropertiesModal from './useViewProtectedPropertiesModal';

const ViewProtectedProperties = () => {
  const { t } = useTranslation();
  const { propertiesUids } = useScreenAndProtectContext();
  const { openViewProtectedPropertiesModal } =
    useViewProtectedPropertiesModal();

  const handleOpenModal = () => {
    openViewProtectedPropertiesModal({
      protectedPropertyUids: propertiesUids,
    });
  };

  return (
    <Button
      bsStyle="link"
      onClick={handleOpenModal}
      data-testid="view-protected-properties"
      data-intercom-target="current-screen-protect-properties"
    >
      {t(
        'pageScreenAndProtect.currentPage.sections.protectionDetails.propertiesValue',
      )}
    </Button>
  );
};

export default ViewProtectedProperties;
